import qs from 'qs'
import { Task } from 'types/Task'
import { TaskShippingAddress } from 'types/TaskShippingAddress'
import { TaskTop } from 'types/TaskTop'
import { apiv2Client } from './apiv2'

export const getTopTask = async (params: {
  groupStatus: string
  nextKey?: string | null
}): Promise<TaskTop> =>
  apiv2Client.get('admin/tasks/top', {
    params,
  })

export const getTasks = async (
  date: string,
  sections?: string[],
): Promise<Task[]> =>
  apiv2Client.get('admin/tasks', {
    params: {
      date,
      sections,
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  })

export const getShippingAddress = async (
  date: string,
): Promise<TaskShippingAddress[]> =>
  apiv2Client.get('admin/tasks/shipping-address', {
    params: {
      date,
    },
    paramsSerializer: params => qs.stringify(params),
  })
